export const questionsWithSections = {
  success: true,
  data: [
    {
      _id: "675038c4945bced0b2951208",
      id: "2",
      formul: null,
      sectionId: "15654",
      questions: [
        {
          questionId: "question21",
          text: "What kind of diet do you follow?",
          type: "select",
          options: [
            {
              key: "Vegan",
              value: "Vegan",
              _id: "675038c4945bced0b295120a",
            },
            {
              key: "Vegetarian",
              value: "Vegetarian",
              _id: "675038c4945bced0b295120b",
            },
            {
              key: "Eggitarian",
              value: "Eggitarian",
              _id: "675038c4945bced0b295120c",
            },
            {
              key: "Non-Vegetarian",
              value: "Non-Vegetarian",
              _id: "675038c4945bced0b295120d",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b2951209",
        },
        {
          questionId: "question21.1",
          text: "Average Quantity of eggs consumed per month",
          type: "text",
          options: [],
          condition: {
            questionId: "question21",
            value: "Eggitarian",
            _id: "675038c4945bced0b295120f",
          },
          _id: "675038c4945bced0b295120e",
        },
        {
          questionId: "question21.2",
          text: "Average Quantity of animal based product consumed per month.(in kgs)",
          type: "text",
          options: [],
          condition: {
            questionId: "question21",
            value: "Non-Vegetarian",
            _id: "675038c4945bced0b2951211",
          },
          _id: "675038c4945bced0b2951210",
        },
        {
          questionId: "question22",
          text: "How much percentage of the food that you eat is unprocessed",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951212",
        },
        {
          questionId: "question23",
          text: "How much percentage of the food that you eat is Packed",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951213",
        },
        {
          questionId: "question24",
          text: "How much percentage of the food that you eat is Locally Grown",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951214",
        },
        {
          questionId: "question25",
          text: "How often do you bathe per week?",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951215",
        },
        {
          questionId: "question26",
          text: "What method do you use for bathing?",
          type: "select",
          options: [
            {
              key: "Tap-Bucket",
              value: "Tap-Bucket",
              _id: "675038c4945bced0b2951217",
            },
            {
              key: "Shower",
              value: "Shower",
              _id: "675038c4945bced0b2951218",
            },
            {
              key: "Bathtub",
              value: "Bathtub",
              _id: "675038c4945bced0b2951219",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b2951216",
        },
        {
          questionId: "question27",
          text: "Please Provide the Percentage",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b295121a",
        },
        {
          questionId: "question28",
          text: "What is the origin of the water supply in your home?",
          type: "select",
          options: [
            {
              key: "Surface water (river, lakes etc.)",
              value: "Surface water (river, lakes etc.)",
              _id: "675038c4945bced0b295121c",
            },
            {
              key: "Groundwater",
              value: "Groundwater",
              _id: "675038c4945bced0b295121d",
            },
            {
              key: "Municipal Water Supply",
              value: "Municipal Water Supply",
              _id: "675038c4945bced0b295121e",
            },
            {
              key: "Water Tanker Supply",
              value: "Water Tanker Supply",
              _id: "675038c4945bced0b295121f",
            },
            {
              key: "Rainwater Harvesting",
              value: "Rainwater Harvesting",
              _id: "675038c4945bced0b2951220",
            },
            {
              key: "Others, please specify ",
              value: "Others, please specify ",
              _id: "675038c4945bced0b2951221",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b295121b",
        },
        {
          questionId: "question29",
          text: "Please Provide the Percentage",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951222",
        },
        {
          questionId: "question210",
          text: "Total water consumption per month",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951223",
        },
        {
          questionId: "question211",
          text: "How often do you wash clothes in a week?",
          type: "select",
          options: [
            {
              key: "0-2 times",
              value: "0-2 times",
              _id: "675038c4945bced0b2951225",
            },
            {
              key: "2-4 times",
              value: "2-4 times",
              _id: "675038c4945bced0b2951226",
            },
            {
              key: "More than 4",
              value: "More than 4",
              _id: "675038c4945bced0b2951227",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b2951224",
        },
        {
          questionId: "question212",
          text: "How do you wash clothes ?",
          type: "radio",
          options: [
            {
              key: "Manual",
              value: "Manual",
              _id: "675038c4945bced0b2951229",
            },
            {
              key: "Machine",
              value: "Machine",
              _id: "675038c4945bced0b295122a",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b2951228",
        },
        {
          questionId: "question213",
          text: "Please Provide the Percentage",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b295122b",
        },
        {
          questionId: "question214",
          text: "What is the amount of waste produced in your household? (in kg)",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b295122c",
        },
        {
          questionId: "question215",
          text: "Do you own any personal vehicles ?",
          type: "radio",
          options: [
            {
              key: "Yes",
              value: "Yes",
              _id: "675038c4945bced0b295122e",
            },
            {
              key: "No",
              value: "No",
              _id: "675038c4945bced0b295122f",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b295122d",
        },
        {
          questionId: "question215-1",
          text: "Number of personal vehicles owned (car/ scooter/ bike etc.)",
          type: "number",
          options: [],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b2951231",
          },
          _id: "675038c4945bced0b2951230",
        },
        {
          questionId: "question215-2",
          text: "Vehicle Type",
          type: "select",
          options: [
            {
              key: "Motorcycle/Scooter",
              value: "Motorcycle/Scooter",
              _id: "675038c4945bced0b2951233",
            },
            {
              key: "Bicycle",
              value: "Bicycle",
              _id: "675038c4945bced0b2951234",
            },
            {
              key: "Car",
              value: "Car",
              _id: "675038c4945bced0b2951235",
            },
            {
              key: "Other, please specify",
              value: "Other, please specify",
              _id: "675038c4945bced0b2951236",
            },
          ],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b2951237",
          },
          _id: "675038c4945bced0b2951232",
        },
        {
          questionId: "question215-3",
          text: "Engine Type",
          type: "select",
          options: [
            {
              key: "Petrol",
              value: "Petrol",
              _id: "675038c4945bced0b2951239",
            },
            {
              key: "Diesel",
              value: "Diesel",
              _id: "675038c4945bced0b295123a",
            },
            {
              key: "CNG",
              value: "CNG",
              _id: "675038c4945bced0b295123b",
            },
            {
              key: "Battery EV",
              value: "Battery EV",
              _id: "675038c4945bced0b295123c",
            },
            {
              key: "Plug in petrol Hybrid EV",
              value: "Plug in petrol Hybrid EV",
              _id: "675038c4945bced0b295123d",
            },
            {
              key: "Plug in Diesel Hybrid EV",
              value: "Plug in Diesel Hybrid EV",
              _id: "675038c4945bced0b295123e",
            },
            {
              key: "Petrol Hybrid EV",
              value: "Petrol Hybrid EV",
              _id: "675038c4945bced0b295123f",
            },
            {
              key: "Diesel Hybrid EV",
              value: "Diesel Hybrid EV",
              _id: "675038c4945bced0b2951240",
            },
            {
              key: "Others, please specify",
              value: "Others, please specify",
              _id: "675038c4945bced0b2951241",
            },
          ],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b2951242",
          },
          _id: "675038c4945bced0b2951238",
        },
        {
          questionId: "question215-4-1",
          text: "Select the segment of Vehicle",
          type: "select",
          options: [
            {
              key: "<1000cc",
              value: "<1000cc",
              _id: "675038c4945bced0b2951244",
            },
            {
              key: "1001-1300cc",
              value: "1001-1300cc",
              _id: "675038c4945bced0b2951245",
            },
            {
              key: "1301-1600cc",
              value: "1301-1600cc",
              _id: "675038c4945bced0b2951246",
            },
            {
              key: "1601-2000cc",
              value: "1601-2000cc",
              _id: "675038c4945bced0b2951247",
            },
            {
              key: "2001-3000cc",
              value: "2001-3000cc",
              _id: "675038c4945bced0b2951248",
            },
            {
              key: ">3000cc",
              value: ">1000cc",
              _id: "675038c4945bced0b2951249",
            },
          ],
          condition: {
            questionId: "question215-2",
            value: "Car",
            _id: "675038c4945bced0b295124a",
          },
          _id: "675038c4945bced0b2951243",
        },
        {
          questionId: "question215-4-2",
          text: "Select the segment of Vehicle",
          type: "select",
          options: [
            {
              key: "6-26 KWh",
              value: "6-26 KWh",
              _id: "675038c4945bced0b295124c",
            },
            {
              key: "27-47 KWh",
              value: "27-47 KWh",
              _id: "675038c4945bced0b295124d",
            },
            {
              key: "48-68 KWh",
              value: "48-68 KWh",
              _id: "675038c4945bced0b295124e",
            },
            {
              key: "69-89 KWh",
              value: "69-89 KWh",
              _id: "675038c4945bced0b295124f",
            },
            {
              key: "90-110 KWh",
              value: "90-110 KWh",
              _id: "675038c4945bced0b2951250",
            },
            {
              key: ">110 KWh",
              value: ">110 KWh",
              _id: "675038c4945bced0b2951251",
            },
          ],
          condition: {
            questionId: "question215-3",
            value: "Battery EV",
            _id: "675038c4945bced0b2951252",
          },
          _id: "675038c4945bced0b295124b",
        },
        {
          questionId: "question215-4-3",
          text: "Select the segment of Vehicle",
          type: "select",
          options: [
            {
              key: "Light Engine Motorcycle, <150cc",
              value: "Light Engine Motorcycle, <150cc",
              _id: "675038c4945bced0b2951254",
            },
            {
              key: "Medium Engine Motorcycle, 151-350cc",
              value: "Medium Engine Motorcycle, 151-350cc",
              _id: "675038c4945bced0b2951255",
            },
            {
              key: "Very High Engine Motorcycle >501cc",
              value: "Very High Engine Motorcycle >501cc",
              _id: "675038c4945bced0b2951256",
            },
          ],
          condition: {
            questionId: "question215-2",
            value: "Motorcycle/Scooter",
            _id: "675038c4945bced0b2951257",
          },
          _id: "675038c4945bced0b2951253",
        },
        {
          questionId: "question215-5",
          text: "Year of Purchase",
          type: "select",
          options: [
            {
              key: "Pre 2015",
              value: "Pre 2015",
              _id: "675038c4945bced0b2951259",
            },
            {
              key: "Post 2015",
              value: "P0st 2015",
              _id: "675038c4945bced0b295125a",
            },
          ],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b295125b",
          },
          _id: "675038c4945bced0b2951258",
        },
        {
          questionId: "question215-6",
          text: "Jan Monthly Distance Travelled (in kms)",
          type: "number",
          options: [],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b295125d",
          },
          _id: "675038c4945bced0b295125c",
        },
        {
          questionId: "question215-7",
          text: "Fab Monthly Distance Travelled (in kms)",
          type: "number",
          options: [],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b295125f",
          },
          _id: "675038c4945bced0b295125e",
        },
        {
          questionId: "question215-8",
          text: "Mar Monthly Distance Travelled (in kms)",
          type: "number",
          options: [],
          condition: {
            questionId: "question215",
            value: "Yes",
            _id: "675038c4945bced0b2951261",
          },
          _id: "675038c4945bced0b2951260",
        },
      ],
      __v: 0,
      createdAt: "2024-12-04T11:11:00.961Z",
      updatedAt: "2024-12-04T11:11:00.961Z",
    },
    {
      _id: "675038c4945bced0b29511fa",
      id: "1",
      formul: null,
      sectionId: "15655",
      questions: [
        {
          questionId: "question11",
          text: "Full Name",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b29511fb",
        },
        {
          questionId: "question12",
          text: "Job Role",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b29511fc",
        },
        {
          questionId: "question13",
          text: "Employee ID",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b29511fd",
        },
        {
          questionId: "question14",
          text: "Workplace Email ID",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b29511fe",
        },
        {
          questionId: "question15",
          text: "Age",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b29511ff",
        },
        {
          questionId: "question16",
          text: "Gender",
          type: "radio",
          options: [
            {
              key: "Male",
              value: "Male",
              _id: "675038c4945bced0b2951201",
            },
            {
              key: "Female",
              value: "Female",
              _id: "675038c4945bced0b2951202",
            },
            {
              key: "Other gender",
              value: "Other gender",
              _id: "675038c4945bced0b2951203",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b2951200",
        },
        {
          questionId: "question17",
          text: "Current Address",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951204",
        },
        {
          questionId: "question18",
          text: "Current Pincode",
          type: "number",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951205",
        },
        {
          questionId: "question19",
          text: "Marital Status",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951206",
        },
        {
          questionId: "question110",
          text: "Family Size",
          type: "text",
          options: [],
          condition: null,
          _id: "675038c4945bced0b2951207",
        },
      ],
      __v: 0,
      createdAt: "2024-12-04T11:11:00.960Z",
      updatedAt: "2024-12-04T11:11:00.960Z",
    },
    {
      _id: "675038c4945bced0b2951208",
      id: "2",
      formul: null,
      sectionId: "15659",
      questions: [
        {
          questionId: "question21",
          text: "What kind of diet do you follow?",
          type: "select",
          options: [
            {
              key: "Vegan",
              value: "Vegan",
              _id: "675038c4945bced0b295120a",
            },
            {
              key: "Vegetarian",
              value: "Vegetarian",
              _id: "675038c4945bced0b295120b",
            },
            {
              key: "Eggitarian",
              value: "Eggitarian",
              _id: "675038c4945bced0b295120c",
            },
            {
              key: "Non-Vegetarian",
              value: "Non-Vegetarian",
              _id: "675038c4945bced0b295120d",
            },
          ],
          condition: null,
          _id: "675038c4945bced0b2951209",
        },
        {
          questionId: "question21.1",
          text: "Average Quantity of eggs consumed per month",
          type: "text",
          options: [],
          condition: {
            questionId: "question21",
            value: "Eggitarian",
            _id: "675038c4945bced0b295120f",
          },
          _id: "675038c4945bced0b295120e",
        },
        // {
        //     "questionId": "question21.2",
        //     "text": "Average Quantity of animal based product consumed per month.(in kgs)",
        //     "type": "text",
        //     "options": [],
        //     "condition": {
        //         "questionId": "question21",
        //         "value": "Non-Vegetarian",
        //         "_id": "675038c4945bced0b2951211"
        //     },
        //     "_id": "675038c4945bced0b2951210"
        // },
        // {
        //     "questionId": "question22",
        //     "text": "How much percentage of the food that you eat is unprocessed",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951212"
        // },
        // {
        //     "questionId": "question23",
        //     "text": "How much percentage of the food that you eat is Packed",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951213"
        // },
        // {
        //     "questionId": "question24",
        //     "text": "How much percentage of the food that you eat is Locally Grown",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951214"
        // },
        // {
        //     "questionId": "question25",
        //     "text": "How often do you bathe per week?",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951215"
        // },
        // {
        //     "questionId": "question26",
        //     "text": "What method do you use for bathing?",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Tap-Bucket",
        //             "value": "Tap-Bucket",
        //             "_id": "675038c4945bced0b2951217"
        //         },
        //         {
        //             "key": "Shower",
        //             "value": "Shower",
        //             "_id": "675038c4945bced0b2951218"
        //         },
        //         {
        //             "key": "Bathtub",
        //             "value": "Bathtub",
        //             "_id": "675038c4945bced0b2951219"
        //         }
        //     ],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951216"
        // },
        // {
        //     "questionId": "question27",
        //     "text": "Please Provide the Percentage",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b295121a"
        // },
        // {
        //     "questionId": "question28",
        //     "text": "What is the origin of the water supply in your home?",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Surface water (river, lakes etc.)",
        //             "value": "Surface water (river, lakes etc.)",
        //             "_id": "675038c4945bced0b295121c"
        //         },
        //         {
        //             "key": "Groundwater",
        //             "value": "Groundwater",
        //             "_id": "675038c4945bced0b295121d"
        //         },
        //         {
        //             "key": "Municipal Water Supply",
        //             "value": "Municipal Water Supply",
        //             "_id": "675038c4945bced0b295121e"
        //         },
        //         {
        //             "key": "Water Tanker Supply",
        //             "value": "Water Tanker Supply",
        //             "_id": "675038c4945bced0b295121f"
        //         },
        //         {
        //             "key": "Rainwater Harvesting",
        //             "value": "Rainwater Harvesting",
        //             "_id": "675038c4945bced0b2951220"
        //         },
        //         {
        //             "key": "Others, please specify ",
        //             "value": "Others, please specify ",
        //             "_id": "675038c4945bced0b2951221"
        //         }
        //     ],
        //     "condition": null,
        //     "_id": "675038c4945bced0b295121b"
        // },
        // {
        //     "questionId": "question29",
        //     "text": "Please Provide the Percentage",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951222"
        // },
        // {
        //     "questionId": "question210",
        //     "text": "Total water consumption per month",
        //     "type": "text",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951223"
        // },
        // {
        //     "questionId": "question211",
        //     "text": "How often do you wash clothes in a week?",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "0-2 times",
        //             "value": "0-2 times",
        //             "_id": "675038c4945bced0b2951225"
        //         },
        //         {
        //             "key": "2-4 times",
        //             "value": "2-4 times",
        //             "_id": "675038c4945bced0b2951226"
        //         },
        //         {
        //             "key": "More than 4",
        //             "value": "More than 4",
        //             "_id": "675038c4945bced0b2951227"
        //         }
        //     ],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951224"
        // },
        // {
        //     "questionId": "question212",
        //     "text": "How do you wash clothes ?",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Manual",
        //             "value": "Manual",
        //             "_id": "675038c4945bced0b2951229"
        //         },
        //         {
        //             "key": "Machine",
        //             "value": "Machine",
        //             "_id": "675038c4945bced0b295122a"
        //         }
        //     ],
        //     "condition": null,
        //     "_id": "675038c4945bced0b2951228"
        // },
        // {
        //     "questionId": "question213",
        //     "text": "Please Provide the Percentage",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b295122b"
        // },
        // {
        //     "questionId": "question214",
        //     "text": "What is the amount of waste produced in your household? (in kg)",
        //     "type": "number",
        //     "options": [],
        //     "condition": null,
        //     "_id": "675038c4945bced0b295122c"
        // },
        // {
        //     "questionId": "question215",
        //     "text": "Do you own any personal vehicles ?",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Yes",
        //             "value": "Yes",
        //             "_id": "675038c4945bced0b295122e"
        //         },
        //         {
        //             "key": "No",
        //             "value": "No",
        //             "_id": "675038c4945bced0b295122f"
        //         }
        //     ],
        //     "condition": null,
        //     "_id": "675038c4945bced0b295122d"
        // },
        // {
        //     "questionId": "question215-1",
        //     "text": "Number of personal vehicles owned (car/ scooter/ bike etc.)",
        //     "type": "number",
        //     "options": [],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b2951231"
        //     },
        //     "_id": "675038c4945bced0b2951230"
        // },
        // {
        //     "questionId": "question215-2",
        //     "text": "Vehicle Type",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Motorcycle/Scooter",
        //             "value": "Motorcycle/Scooter",
        //             "_id": "675038c4945bced0b2951233"
        //         },
        //         {
        //             "key": "Bicycle",
        //             "value": "Bicycle",
        //             "_id": "675038c4945bced0b2951234"
        //         },
        //         {
        //             "key": "Car",
        //             "value": "Car",
        //             "_id": "675038c4945bced0b2951235"
        //         },
        //         {
        //             "key": "Other, please specify",
        //             "value": "Other, please specify",
        //             "_id": "675038c4945bced0b2951236"
        //         }
        //     ],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b2951237"
        //     },
        //     "_id": "675038c4945bced0b2951232"
        // },
        // {
        //     "questionId": "question215-3",
        //     "text": "Engine Type",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Petrol",
        //             "value": "Petrol",
        //             "_id": "675038c4945bced0b2951239"
        //         },
        //         {
        //             "key": "Diesel",
        //             "value": "Diesel",
        //             "_id": "675038c4945bced0b295123a"
        //         },
        //         {
        //             "key": "CNG",
        //             "value": "CNG",
        //             "_id": "675038c4945bced0b295123b"
        //         },
        //         {
        //             "key": "Battery EV",
        //             "value": "Battery EV",
        //             "_id": "675038c4945bced0b295123c"
        //         },
        //         {
        //             "key": "Plug in petrol Hybrid EV",
        //             "value": "Plug in petrol Hybrid EV",
        //             "_id": "675038c4945bced0b295123d"
        //         },
        //         {
        //             "key": "Plug in Diesel Hybrid EV",
        //             "value": "Plug in Diesel Hybrid EV",
        //             "_id": "675038c4945bced0b295123e"
        //         },
        //         {
        //             "key": "Petrol Hybrid EV",
        //             "value": "Petrol Hybrid EV",
        //             "_id": "675038c4945bced0b295123f"
        //         },
        //         {
        //             "key": "Diesel Hybrid EV",
        //             "value": "Diesel Hybrid EV",
        //             "_id": "675038c4945bced0b2951240"
        //         },
        //         {
        //             "key": "Others, please specify",
        //             "value": "Others, please specify",
        //             "_id": "675038c4945bced0b2951241"
        //         }
        //     ],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b2951242"
        //     },
        //     "_id": "675038c4945bced0b2951238"
        // },
        // {
        //     "questionId": "question215-4-1",
        //     "text": "Select the segment of Vehicle",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "<1000cc",
        //             "value": "<1000cc",
        //             "_id": "675038c4945bced0b2951244"
        //         },
        //         {
        //             "key": "1001-1300cc",
        //             "value": "1001-1300cc",
        //             "_id": "675038c4945bced0b2951245"
        //         },
        //         {
        //             "key": "1301-1600cc",
        //             "value": "1301-1600cc",
        //             "_id": "675038c4945bced0b2951246"
        //         },
        //         {
        //             "key": "1601-2000cc",
        //             "value": "1601-2000cc",
        //             "_id": "675038c4945bced0b2951247"
        //         },
        //         {
        //             "key": "2001-3000cc",
        //             "value": "2001-3000cc",
        //             "_id": "675038c4945bced0b2951248"
        //         },
        //         {
        //             "key": ">3000cc",
        //             "value": ">1000cc",
        //             "_id": "675038c4945bced0b2951249"
        //         }
        //     ],
        //     "condition": {
        //         "questionId": "question215-2",
        //         "value": "Car",
        //         "_id": "675038c4945bced0b295124a"
        //     },
        //     "_id": "675038c4945bced0b2951243"
        // },
        // {
        //     "questionId": "question215-4-2",
        //     "text": "Select the segment of Vehicle",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "6-26 KWh",
        //             "value": "6-26 KWh",
        //             "_id": "675038c4945bced0b295124c"
        //         },
        //         {
        //             "key": "27-47 KWh",
        //             "value": "27-47 KWh",
        //             "_id": "675038c4945bced0b295124d"
        //         },
        //         {
        //             "key": "48-68 KWh",
        //             "value": "48-68 KWh",
        //             "_id": "675038c4945bced0b295124e"
        //         },
        //         {
        //             "key": "69-89 KWh",
        //             "value": "69-89 KWh",
        //             "_id": "675038c4945bced0b295124f"
        //         },
        //         {
        //             "key": "90-110 KWh",
        //             "value": "90-110 KWh",
        //             "_id": "675038c4945bced0b2951250"
        //         },
        //         {
        //             "key": ">110 KWh",
        //             "value": ">110 KWh",
        //             "_id": "675038c4945bced0b2951251"
        //         }
        //     ],
        //     "condition": {
        //         "questionId": "question215-3",
        //         "value": "Battery EV",
        //         "_id": "675038c4945bced0b2951252"
        //     },
        //     "_id": "675038c4945bced0b295124b"
        // },
        // {
        //     "questionId": "question215-4-3",
        //     "text": "Select the segment of Vehicle",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Light Engine Motorcycle, <150cc",
        //             "value": "Light Engine Motorcycle, <150cc",
        //             "_id": "675038c4945bced0b2951254"
        //         },
        //         {
        //             "key": "Medium Engine Motorcycle, 151-350cc",
        //             "value": "Medium Engine Motorcycle, 151-350cc",
        //             "_id": "675038c4945bced0b2951255"
        //         },
        //         {
        //             "key": "Very High Engine Motorcycle >501cc",
        //             "value": "Very High Engine Motorcycle >501cc",
        //             "_id": "675038c4945bced0b2951256"
        //         }
        //     ],
        //     "condition": {
        //         "questionId": "question215-2",
        //         "value": "Motorcycle/Scooter",
        //         "_id": "675038c4945bced0b2951257"
        //     },
        //     "_id": "675038c4945bced0b2951253"
        // },
        // {
        //     "questionId": "question215-5",
        //     "text": "Year of Purchase",
        //     "type": "select",
        //     "options": [
        //         {
        //             "key": "Pre 2015",
        //             "value": "Pre 2015",
        //             "_id": "675038c4945bced0b2951259"
        //         },
        //         {
        //             "key": "Post 2015",
        //             "value": "P0st 2015",
        //             "_id": "675038c4945bced0b295125a"
        //         }
        //     ],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b295125b"
        //     },
        //     "_id": "675038c4945bced0b2951258"
        // },
        // {
        //     "questionId": "question215-6",
        //     "text": "Jan Monthly Distance Travelled (in kms)",
        //     "type": "number",
        //     "options": [],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b295125d"
        //     },
        //     "_id": "675038c4945bced0b295125c"
        // },
        // {
        //     "questionId": "question215-7",
        //     "text": "Fab Monthly Distance Travelled (in kms)",
        //     "type": "number",
        //     "options": [],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b295125f"
        //     },
        //     "_id": "675038c4945bced0b295125e"
        // },
        // {
        //     "questionId": "question215-8",
        //     "text": "Mar Monthly Distance Travelled (in kms)",
        //     "type": "number",
        //     "options": [],
        //     "condition": {
        //         "questionId": "question215",
        //         "value": "Yes",
        //         "_id": "675038c4945bced0b2951261"
        //     },
        //     "_id": "675038c4945bced0b2951260"
        // }
      ],
      __v: 0,
      createdAt: "2024-12-04T11:11:00.961Z",
      updatedAt: "2024-12-04T11:11:00.961Z",
    },
  ],
  message: "calculate MobileFuelEmission successfully",
};
